
import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import React from "react";




export default function HistoricoPagamento({
  historicoPagamento
}: {
  historicoPagamento
  : any
}) {
  const { t } = useTranslation();
  historicoPagamento.data.sort((a:any, b:any) => {
    const nameA = new Date(a.data); 
    const nameB = new Date(b.data); 
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  });
  const headerTemplate = (data:any) => {
    console.log(data)
    return (
        <React.Fragment>
            <div className="flex-score align-items-center gap-2"><h3>CNPJ: </h3> {data.doc}</div>
        </React.Fragment>
    );
};
  const footerTemplate = (data:any) => {
    console.log(data)
    return (
      <React.Fragment>
      <td style={{background: '#f9fafb'}} colSpan={2}>
          <div className="flex-score w-full"><h3>Total em 6 meses </h3> </div>
      </td>
      <td style={{background: '#f9fafb'}} colSpan={5}>
          <div className="flex-score w-full"><p><h3>Valor parcelamento pago: </h3>{data.footerValor}</p></div>
      </td>
      <td style={{background: '#f9fafb'}} colSpan={3}>
          <div className="flex-score w-full"><p><h3 >Total parcelamento pago: </h3> {data.footerTotal}</p></div>
      </td>
  </React.Fragment>
        
    );
};
  return (
    <Panel header={t('historicoPagamento')} style={{width:'98%'}}>
       
       {historicoPagamento.columns && (
        <DataTable emptyMessage="Nenhuma informação disponível" rowGroupMode="subheader" rowGroupHeaderTemplate={headerTemplate} sortField="doc" sortOrder={0} sortMode="single" groupRowsBy="doc" size="small" rowGroupFooterTemplate={footerTemplate} value={historicoPagamento.data} tableStyle={{ minWidth: '50rem' }}>
          {historicoPagamento.columns.filter((col:any) => col.header !== 'CNPJ').map((col:any) => (
                      <Column key={col.field} field={col.field} header={col.header} />
                  ))}
        </DataTable>
       )}
       <p>{historicoPagamento.message}</p>
    </Panel>
  )
}
